const api = {};

if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {

      if (this === null) {
        throw new TypeError('"this" is null or not defined');
      }

      // 1. Let O be ? ToObject(this value).
      const o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      const len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      const n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        // c. Increase k by 1. 
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}

api.helpers = {};
api.helpers.page = (page, size, axiosConfig) => {
  if (utils.isNullOrUndefined(axiosConfig)) {
    console.log('axios config is null');
    return;
  }

  if (utils.isNullOrUndefined(axiosConfig.params)) {
    axiosConfig.params = {};
  }

  axiosConfig.params.paging = {
    num: page,
    size: size
  };

  // technically don't need to return it, the object is already updated
  // doing it as more of a pass through
  return axiosConfig;
};

api.helpers.logErrorObject = (error) => {
  // console.log(error);
  if (!utils.isNullOrUndefined(error.response) &&
    error.response.status === 400) {
    console.log(error.response.data);
  } else {
    console.error(error);
  }
};

api.helpers.complexParams = (axiosConfig) => {
  const ob = axiosConfig.params || {};
  const params = {};
  for (const key in ob) {
    if (!ob.hasOwnProperty(key)) {
      continue;
    }
    const value = ob[key];
    if (value instanceof Array) {
      
    } else if (value instanceof Object) {
      for (const subKey in value) {
        if (!value.hasOwnProperty(subKey)) {
          continue;
        }
        const newKey = `${key}[${subKey}]`;
        params[newKey] = value[subKey];
      }
    } else {
      params[key] = value;
    }
  }

  axiosConfig.params = params;
  return axiosConfig;
};

api.helpers.JWT_COOKIE_NAME = 'jwt_token';
api.helpers.XSRF_COOKIE_NAME = 'X-XSRF';
/* global Cookies, axios */
class Authenticated {
  constructor() {
    const token = Cookies.get(api.helpers.JWT_COOKIE_NAME);

    if (utils.isNullOrUndefined(token)) {
      console.error('No user available');
      window.location = '/login';
      return;
    }
  }

  setTokenCookie(token) {
    Cookies.set(api.helpers.JWT_COOKIE_NAME, token);
  }

  getUser() {
    const token = Cookies.get(api.helpers.JWT_COOKIE_NAME);

    if (utils.isNullOrUndefined(token)) {
      console.error('No user available');
      window.location = '/login';
      return;
    }

    const jwtParts = token.split('.');
    const payload = jwtParts[1];

    const decoded = window.atob(payload);
    const tokenObj = JSON.parse(decoded);

    return {
      jti: tokenObj.jti,
      username: tokenObj.uname,
      currentTenant: tokenObj.txref,
      backOffice: tokenObj.hasOwnProperty('backoffice')
    };
  }

  signout() {
    Cookies.remove(api.helpers.JWT_COOKIE_NAME, '');
    window.location = '/login';
  }

  authReq(axiosConfig) {
    const jwtName = api.helpers.JWT_COOKIE_NAME;
    const token = Cookies.get(jwtName);

    let hasError = false;
    if (utils.isNullOrUndefined(token)) {
      console.error(`Can't find ${jwtName} cookie`);
      hasError = true;
    } 

    if (hasError) {
      window.location = '/login';
      return;
    }

    axiosConfig.headers = axiosConfig.headers || {};

    axiosConfig.headers['Authorization'] = `Bearer ${token}`;

    const newConfig = api.helpers.complexParams(axiosConfig);
    const req = axios(newConfig);

    req.catch(error => {
      if (!utils.isNullOrUndefined(error.response)) {
        if (error.response.status === 401) {
          // Probably needs to be more graceful than this
          window.location = '/login';
        }
      } 
    });

    return req;
  }
}
class MigrationRunner {
  constructor(app) {
    this.app = app;
    /* 
     * list of migration functions to run
     * should take the form of f(app)
     */
    this.migrations = [];
  }

  runMigrations() {
    const savedVersion = this.app.getSavedVersion();
    const currentVersion = this.app.getClientVersion();
    console.log('Start migration');
    console.log(`Current ClientVersion: ${currentVersion}`);
    console.log(`Saved ClientVersion: ${savedVersion}`);

    if (!utils.isNullOrUndefined(savedVersion) && savedVersion >= currentVersion) {
      console.log('nothing to run, versions match');
      return;
    }

    for (let i = 0; i < this.migrations.length; i++) {
      this.migrations[i](this.app);
    }

    console.log('End migration');
  }
}
const utils = {};

utils.isNullOrUndefined = (arg) => {
  return arg === null || arg === undefined || arg === '';
};

utils.isEmpty = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
};

// FIXME: the scrollTo function used inside this function is not right. (Dan Alexander)
/* utils.scrollTo = (element, to, duration) => {
  if (duration <= 0) return;
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;

  setTimeout(function () {
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  }, 10);
};*/

utils.groupBy = (xs, key) => {
  return xs.reduce((rv, x) => {
    const v = key instanceof Function ? key(x) : x[key];
    const el = rv.find((r) => r && r.key === v); 
    if (el) {
     el.values.push(x);
    } else {
     rv.push({ key: v, values: [x] });
    }
    return rv;
  }, []);
};

utils.GetComposedPath = (element) => {
  if (element === null) {
    return [];
  }

  const pathArr = [element];

  while (element.parentElement !== null) {
    element = element.parentElement;
    pathArr.unshift(element);
  }

  return pathArr;
};

/**
 * Used to completely stop event propagation
 * @param event
 */
utils.stopEvent = (event) => {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
};

riot.tag2('content-pagination', '<virtual if="{totalPages > 1}"><ul class="inline-list pagination-list"><li class="pagination-start" if="{currentPage > 1}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{0}"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 15 12" width="15" height="12"><path d="M7 6.1L12.3.7l.7.7-4.6 4.7 4.6 4.6-.7.7L7 6.1z"></path><path d="M8 10.7l-.7.7L2 6.1 7.3.7l.7.7-4.6 4.7"></path></svg></button></li><li class="pagination-prev" if="{currentPage > 0}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{currentPage - 1}"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 10 12" width="10" height="12"><path d="M2.1 6L7.4.6l.7.8L3.5 6l4.6 4.6-.7.7L2.1 6z"></path></svg></button></li><li class="pagination-page {active: num == currentPage}" each="{num in leadUp}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{num}">{num + 1}</button></li><virtual if="{tailNeeded}"><li class="pagination-page" if="{totalPages > minNumForDots}"><p class="pagination-link">...</p></li></virtual><virtual if="{currentPage != totalPages - 1}"><li class="pagination-page {active: (totalPages - 1) == currentPage}" if="{totalPages > minNumForDots}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{totalPages - 1}">{totalPages}</button></li></virtual><li class="pagination-next" if="{currentPage < totalPages - 1}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{nextPage}"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 10 12" width="10" height="12"><path d="M2.8 11.3l-.7-.7L6.7 6 2.1 1.4l.7-.8L8.1 6z"></path></svg></button></li><li class="pagination-end" if="{currentPage < totalPages - 2}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{totalPages - 1}"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 15 12" width="15" height="12"><path d="M2.7 11.4l-.7-.7L6.6 6 2 1.4l.7-.8L8 6.1l-5.3 5.3z"></path><path d="M11.6 6.1L7 1.4l.7-.8L13 6.1l-5.3 5.3-.7-.7"></path></svg></button></li></ul></virtual>', '', 'class="pagination"', function(opts) {
    const app = this.opts.app;
    this.app = app;

    this.currentPage = app.currentPage;
    this.nextPage = parseInt(this.currentPage) + 1;
    this.totalPages = app.totalPages;

    this.prevDots = true;
    this.postDots = false;

    this.minNumForDots = 6;
    this.tailNeeded = true;

    this.getLeadup = () => {
      if(this.totalPages <= this.minNumForDots) {
        this.leadUp = [];
        for(let i = 0; i < this.totalPages; i++) {
          this.leadUp.push(i);
        }
      } else if(this.currentPage < 4) {
        this.leadUp = [0,1,2,3];
      } else {
        this.leadUp = [(this.currentPage - 3),
          (this.currentPage - 2),
          (this.currentPage - 1),
          (parseInt(this.currentPage))];
        if(this.currentPage >= this.totalPages - 2) {
          this.tailNeeded = false;
        } else {
          this.tailNeeded = true;
        }
      }
    }

    this.getLeadup();

    this.pageClicked = (e) => {
      this.currentPage = e.target.value;
      app.pageChange(e.target.value);
    }

    this.sortChanged = () => {
      this.currentPage = app.currentPage;
      this.nextPage = parseInt(this.currentPage) + 1;
      this.totalPages = app.totalPages;
      this.getLeadup();
      this.update();
    }

    this.on('mount', () => {
      app.on('sortChanged', this.sortChanged);
    });

    this.on('unmount', () => {
      app.off('sortChanged', this.sortChanged);
    });
});

riot.tag2('content-wysiwyg-editor', '<div class="form"><div><textarea name="Description" id="Description" cols="30" rows="8" class="field">This is a post Description. Citizens of distant epochs shores of the cosmic ocean the sky calls to us inconspicuous motes of rock and gas. Worldlets. Cosmic ocean! Hundreds of thousands, dispassionate extraterrestrial observer laws of physics, Vangelis made in the interiors of collapsing stars a billion trillion tesseract dream of the mind\'s eye a still more glorious dawn awaits brain is the seed of intelligence! Courage of our questions.</textarea></div><div><button class="btn btn-small" onclick="{getData}"> Get Data </button></div></div>', 'content-wysiwyg-editor,[data-is="content-wysiwyg-editor"]{ display: block; }', '', function(opts) {

    const app = this.opts.app;
    this.app = app;
    this.tinyData;

    tinymce.init({
      selector:'#Description',
      plugins: ['link', 'textcolor'],
      toolbar: [ 'undo redo | bold italic | template codesample | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist | link'],
      statusbar: false,
      resize: false
    });

    this.getData = (e) => {
      this.tinyData = tinymce.get('Description').getContent();
      this.update();
      console.log(this.tinyData);
    }

});
riot.tag2('custom-dropdown', '<div class="field-wrap custom-select-wrap"><i class="custom-select-icon"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 8 12" width="8" height="12" width="8" height="12"><path d="M8 6L1.6 0 0 1.5 4.8 6 0 10.5 1.6 12 8 6z"></path></svg></i><label for="{nameId}" class="form-label {inline-label: opts.inline}">{opts.label} </label><select name="{nameId}" id="{nameId}" placeholder="{placeholder}"><virtual if="{!opts.options}"><yield></yield></virtual><option value="null">select one</option><option each="{choices}" riot-value="{id}" selected="{id == selectedId}">{value}</option></select></div>', '', '', function(opts) {
    const app = this.opts.app;
    this.app = app;
    this.choices = this.opts.choices;
    this.control = this.opts.control;
    this.userValue = this.opts.uservalue;
    this.isselected = this.opts.isselected;
    this.sectionId = this.opts.sectionid;

    this.isSorter = this.opts.issorter;
    this.sorterType = this.opts.sortertype;

    if(this.sorterType == 'status') {
      if(!utils.isNullOrUndefined(this.choices)) {
        for(let i = 0; i < this.choices.length; i++) {
          this.choices[i].value = this.choices[i].name;
        }
      }
    }

    if(!utils.isNullOrUndefined(this.control)) {
      this.placeholder = this.control.placeholderText;
      this.nameId =
        `${this.control.type}-${this.control.subtype}-${this.control.id}`;
    }

    this.selectionChanged = (value) => {
      if(!utils.isNullOrUndefined(this.control)) {
        let selectionObj = {
          controlId: this.control.id,
          controlValue: value
        };
        app.fieldChanged(selectionObj, this.sectionId);
        this.userValue.controlValue = value;
      } else if(this.isSorter) {
        this.app.sortChanged(this.sorterType, value);
      }
    }

    if(!utils.isNullOrUndefined(this.userValue)) {
      if(!utils.isNullOrUndefined(this.userValue.controlValue)) {
        this.selectedId = this.userValue.controlValue;
      } else {
        this.selectionChanged(this.choices[0].id);
      }
    }

    if(!utils.isNullOrUndefined(this.isselected)) {
      this.selectedId = this.isselected;
      this.selectionChanged(this.selectedId);
    }

    const toggleSelected = ($dropdown) => {

      let ival = this.root.querySelector('.item').getAttribute('data-value');

      let opts = $dropdown[0].querySelectorAll('.option');

      for (let i=0;i<opts.length;i++) {

        if (opts[i].getAttribute('data-value') !== ival) {

          opts[i].classList.remove('is-selected');
        } else {

          opts[i].classList.add('is-selected');
        }
      }
    };

    this.on('mount', () => {
      const options = opts.options;
      const s = $(this.root.querySelector('select')).selectize({
        onDropdownOpen: toggleSelected,
        onChange: this.selectionChanged,
        valueField: 'id',
        labelField: 'text',
        options: options,
        placeholder: this.placeholder
      });
    });

});

riot.tag2('custom-image-upload', '<label for="Image" class="custom-file-outer"><p class="label">Image</p><input ref="fileName" onchange="{fileChange}" name="Image" id="Image" class="visuallyhidden" type="file" multiple="" accept=".jpg, .gif, .svg, .bmp, .pdf"><span id="Info" class="custom-file-label field">Upload image</span></label><button class="custom-file-remove" if="{hasFile}" onclick="{fileRemove}"><i class="custom-file-remove-icon icon"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 15 18" width="15" height="18"><path d="M1.1 16c0 1.1 1 2 2.1 2h8.6c1.2 0 2.1-.9 2.1-2V4H1.1v12zM15 1h-3.8l-1.1-1H4.8l-1 1H0v2h15V1z"></path></svg></i><span>Remove image</span></button>', 'custom-image-upload,[data-is="custom-image-upload"]{ display: block; }', '', function(opts) {
    const files = [];

    this.hasFile = false;
    this.app = this.opts.app;

    this.fileChange = () => {
      let i = this.root.querySelector('#Info');
      let f = this.refs.fileName.value;
      let t = f.replace(/^.*[\\\/]/, '');

      if (f) {
        this.hasFile = true;
        files.push(f);
        i.innerText = t;
      }
    }

    this.fileRemove = () => {
      let i = this.root.querySelector('#Info');
      files.pop();
      this.hasFile = false;
      i.innerText = 'Upload image';
    }

});
riot.tag2('custom-multi-dropdown', '<label for="{nameId}" class="form-label block-label visuallyhidden">{label}</label><select name="{nameId}" id="{nameId}" multiple placeholder="{placeholder}"><virtual if="{!opts.options}"><yield></yield></virtual></select>', 'custom-multi-dropdown,[data-is="custom-multi-dropdown"]{ display: block; }', '', function(opts) {
    const app = this.opts.app;
    this.app = app;
    this.control = this.opts.control;
    this.userValues = this.opts.uservalues;
    this.controlValuesArray = [];
    this.secitonId = this.opts.sectionid;
    if(!utils.isNullOrUndefined(this.userValues)) {
      for(let i = 0; i < this.userValues.length; i++) {
        if(this.userValues[i].controlId == this.control.id) {
          this.controlValuesArray.push(this.userValues[i].controlValue);
        }
      }
    }

    this.options = this.opts.options;

    if(!utils.isNullOrUndefined(this.control)) {
      this.placeholder = this.control.placeholderText;
      this.label = this.control.label;
      this.nameId =
        `${this.control.type}-${this.control.subtype}-${this.control.id}`;
    }

    this.itemChanged = (itemsArray) => {
      app.multiFieldChanged(this.control.id, itemsArray, this.sectionId);
      this.controlValuesArray = itemsArray;
    }

    this.on('mount', () => {
      const options = this.options;
      const s = $(this.root.querySelector('select')).selectize({
        plugins: ['remove_button'],
        valueField: 'id',
        labelField: 'value',
        create: false,
        options: options,
        onChange: this.itemChanged
      })[0].selectize;
      s.setValue(this.controlValuesArray);
    });

});
riot.tag2('message-bar', '<div show="{showAlert}" class="message-bar {color}"><div class="message"> {message} </div></div>', '', 'class="message-bar"', function(opts) {
var _this = this;
var app = this.opts.app;
this.color = '';
this.message = '';
this.alert = function (msg) {
  _this.message = msg.message;
  _this.showAlert = true;
  switch (msg.type) {
    case 'success':
      _this.color = "message-bar-success";
      break;
    case 'error':
      _this.color = "message-bar-error";
      break;
  }
  setTimeout(function () {
    _this.showAlert = false;
    _this.update();
  }, 10000);
  _this.update();
};
this.on('mount', function () {
  _this.showAlert = false;
  app.on('alert', _this.alert);
});
this.off('unmount', function () {
  _this.showAlert = false;
  app.off('alert', _this.alert);
});
});
riot.tag2('modal-popup', '<button onclick="{click}"><yield from="icon"></yield></button><div class="modal-bg" if="{showmodal}"></div><div class="modal" if="{showmodal}"><button class="modal-close icon" onclick="{click}"><span class="visuallyhidden">Icon: X close</span><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 18" width="18" height="18"><path d="M9 7.4L1.6 0 0 1.6 7.4 9 0 16.4 1.6 18 9 10.6l7.4 7.4 1.6-1.6L10.6 9 18 1.6 16.4 0 9 7.4z"></path></svg></button><div class="modal-header"><yield from="header"></yield></div><div class="modal-body"><yield from="body"></yield></div><div class="modal-footer btn-group"><button class="btn" onclick="{click}">Cancel</button><button class="btn btn-dark">Save</button></div></div>', 'modal-popup,[data-is="modal-popup"]{ display: block; }', '', function(opts) {
    this.showmodal = false;

    this.click = (event) => {
      this.showmodal = !this.showmodal;
    }
});
riot.tag2('multi-dropdown', '<select name="{opts.id}" id="{opts.id}" multiple placeholder="Insert contacts..."><virtual if="{!opts.options}"><yield></yield></virtual></select>', 'multi-dropdown,[data-is="multi-dropdown"]{ display: block; line-height: 0.8; position: relative; z-index: 1; }', '', function(opts) {
    this.on('mount', () => {
      const options = opts.options;
      $(this.root.querySelector('select')).selectize({
        plugins: ['remove_button'],
        valueField: 'id',
        labelField: 'text',
        create: false,
        options: options
      });
    });
});
riot.tag2('prompt-modal', '<div style="display: none;"><yield></yield></div><virtual if="{active}"><div class="modal-bg"></div><div class="modal"><button class="modal-close icon" onclick="{cancelClick}"><span class="visuallyhidden">Icon: X close</span><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 18" width="18" height="18"><switch><path d="M17.272 1.522l-.794-.794L9 8.205 1.522.728l-.794.794L8.205 9 .728 16.478l.794.794L9 9.795l7.478 7.477.794-.794L9.795 9z"></path></switch></svg></button><div class="modal-header"><h2 class="modal-title headline">{headline}</h2><p class="modal-info intro">{intro}</p></div><div ref="modalContent" class="modal-body"><yield from="body"></yield></div><div class="modal-controls button-group"><button each="{button in buttons}" onclick="{buttonClick}" class="{button.type}"> {button.text} </button></div></div></virtual>', 'prompt-modal,[data-is="prompt-modal"]{ display: block; }', '', function(opts) {
    this.headline = opts.headline || 'Are you sure?';
    this.intro = opts.intro || 'This action can\'t be undone.';
    this.active = !!opts.showmodal;
    this.onChoice = opts.onchoice || null;
    this.buttons = [
      { value: 'cancel', text: 'Cancel', type: 'btn btn-dark' },
      { value: 'confirm', text: 'Confirm', type: 'btn' }
    ];

    this.on('mount', () => {

      const optionList = this.root.querySelectorAll('option');
      if (optionList.length > 0) {
        this.buttons = [];
        for (let i = 0; i < optionList.length; ++i) {
          const opt = optionList[i];

          const b = {
            value: opt.value,
            text: opt.textContent,
            type: opt.getAttribute('type') || 'btn'
          };
          this.buttons.push(b);
        }
      }
    });

    this.activate = () => {
      this.active = true;
      this.update();
    }

    this.buttonClick = (e) => {
      e.preventDefault();
      this.active = false;
      if (!utils.isNullOrUndefined(this.onChoice)) {
        this.onChoice(e, e.item.button.value);
      }
    };

    this.cancelClick = (e) => {
      e.preventDefault();
      this.active = false;
      if (!utils.isNullOrUndefined(this.onChoice)) {
        this.onChoice(e, 'close');
      }
    };

});
riot.tag2('tab-layout', '<div class="tabs"><div class="tab-content group"><yield from="content"></yield></div></div>', 'tab-layout,[data-is="tab-layout"]{ display: block; }', '', function(opts) {
    this.on('mount', () => {
      const tabContent = this.root.querySelector('.tab-content');
      const tabBodies = this.root.querySelectorAll('.tab-body');
      let num = 0;

      for (const tabBody of tabBodies) {
        let input = document.createElement('input');
        let label = document.createElement('label');
        let span = document.createElement('span');
        let spanspan = document.createElement('span');

        tabBody.setAttribute('data-tab-index', num);

        input.setAttribute('name', 'tab');
        input.setAttribute('id', tabBody.dataset.title);
        input.setAttribute('class', 'visuallyhidden tab-');
        input.setAttribute('type', 'radio');
        input.setAttribute('data-tab-index', num);

        let classList = 'tab-mark';
        if(tabBody.classList.contains('disabled')) {
          classList += ' disabled';
        }

        label.setAttribute('for', tabBody.dataset.title);
        label.setAttribute('class', classList);

        span.setAttribute('class', 'tab-title');
        span.innerText = tabBody.dataset.title;
        label.prepend(span);

        if (tabBody.dataset.hasOwnProperty('info')) {
          spanspan.setAttribute('class', 'tab-info');
          spanspan.innerText = tabBody.dataset.info;
          label.append(spanspan);
        }

        tabContent.parentNode.insertBefore(input, tabContent);
        tabContent.parentNode.insertBefore(label, tabContent);

        num++;
      }

      tabContent.parentNode.childNodes[0].setAttribute('checked', true);
    });
});
riot.tag2('toast-notification', '<div each="{toast in toasts}" class="toast-message toast-{toast.type}"> {toast.message} </div>', '', 'class="toast-container toast-top-right"', function(opts) {
var _this = this;
var app = this.opts.app;
this.toasts = [];
this.toast = function (toast) {
  _this.toasts.push(toast);
  _this.update();
  setTimeout(function () {
    return _this.removeToast(toast);
  }, 6000);
};
this.removeToast = function (toast) {
  var index = _this.toasts.indexOf(toast);
  _this.toasts.splice(index, 1);
  _this.update();
};
this.on('mount', function () {
  app.on('toast', _this.toast);
});
this.on('unmount', function () {
  app.off('toast', _this.toast);
});
});